import React from 'react';
import { Grid, Skeleton } from '@mui/material';
import { isBaseFormFieldType } from '@/components';
import { FormField } from '@/type';
import { MULTIROW_HEIGHT, SINGLE_ROW_HEIGHT } from '@/constant';

interface DynamicFormLoadingSkeletonProps {
  formFields: FormField[];
}

export const DynamicFormLoadingSkeleton = ({
  formFields,
}: DynamicFormLoadingSkeletonProps) => {
  return (
    <>
      {formFields.map((field, index) => (
        <Grid item xs={'xs' in field ? field.xs : 12} key={`skeleton-${index}`}>
          <Skeleton
            height={
              isBaseFormFieldType(field) && 'isMultiRow' in field && field.isMultiRow
                ? MULTIROW_HEIGHT
                : SINGLE_ROW_HEIGHT
            }
            animation='pulse'
            variant='circular'
            sx={{ borderRadius: 2 }}
          />
        </Grid>
      ))}
    </>
  );
};
